import React from 'react';
import {EditIcon, UnionIcon} from 'shared/icons';
import type {ProfileViewModel} from '../../model';
import styles from './ProfileData.module.css';

type ProfileField = {
	label: string;
	key: string;
	labelClassName?: string;
	render: () => React.ReactNode;
};

type ProfileDataProps = {
	profile: ProfileViewModel;
	onEditEmail?: () => void;
};

function CitizenshipValue({
	isRussia,
	countryName,
}: {
	isRussia: boolean;
	countryName: string;
}): React.ReactElement {
	return (
		<span className={styles.citizenship}>
			{isRussia ? (
				<span className={styles.flag} aria-hidden />
			) : (
				<span className={styles.flagFallback} aria-hidden>
					<UnionIcon width={10} height={12} />
				</span>
			)}
			<span>{countryName}</span>
		</span>
	);
}

export function ProfileData({profile, onEditEmail}: ProfileDataProps): React.ReactElement {
	const fields: ProfileField[] = [
		{
			key: 'citizenship',
			label: 'Гражданство',
			render: () => (
				<CitizenshipValue isRussia={profile.isRussiaCitizenship} countryName={profile.citizenshipName} />
			),
		},
		{
			key: 'residence',
			label: 'Страна проживания (налогового резидентства)',
			labelClassName: styles.labelWide,
			render: () => (
				<CitizenshipValue isRussia={profile.isRussiaResidence} countryName={profile.residenceName} />
			),
		},
		{
			key: 'gender',
			label: 'Пол',
			render: () => profile.gender,
		},
		{
			key: 'secondName',
			label: 'Фамилия',
			render: () => profile.secondName,
		},
		{
			key: 'firstName',
			label: 'Имя',
			render: () => profile.firstName,
		},
		{
			key: 'patronymic',
			label: 'Отчество',
			render: () => profile.patronymic,
		},
		{
			key: 'phone',
			label: 'Телефон',
			render: () => profile.phone,
		},
		{
			key: 'email',
			label: 'E-mail',
			render: () => (
				<span className={styles.emailRow}>
					<span className={styles.emailText}>{profile.email}</span>
					{onEditEmail ? (
						<button type="button" className={styles.editIcon} aria-label="Редактировать e-mail" onClick={onEditEmail}>
							<EditIcon width={20} height={20} />
						</button>
					) : (
						<span className={styles.editIcon} aria-hidden>
							<EditIcon width={20} height={20} />
						</span>
					)}
				</span>
			),
		},
	];

	return (
		<dl className={styles.root}>
			{fields.map((field) => (
				<div key={field.key} className={styles.field}>
					<dt className={field.labelClassName ? `${styles.label} ${field.labelClassName}` : styles.label}>
						{field.label}
					</dt>
					<dd className={styles.value}>{field.render()}</dd>
				</div>
			))}
		</dl>
	);
}
